// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__wqf96","additionalInfo":"AgreementModal_additionalInfo__19EjC"};